import { Card } from "react-bootstrap";
import { LoadingSpinner } from "../../Abstractions/LoadingSpinner";
import { BadgeDomain } from "../../Abstractions/BadgeDomain";
import { RefreshKpoCard } from "../../../useCases/orders/refreshKpoCards/RefreshKpoCard";
import { KpoBdoCardDetailsOffcanvas } from "../../Bdo/Kpo/KpoBdoCardDetailsOffcanvas";
import { KpoLinkFromOrder, KpoUnlinkFromOrder } from "./Actions/KpoUnlinkFromOrder";
import { KpoDriverExclude, KpoDriverInclude } from "./Actions/KpoDriverExclude";
import { OrderKpoCardActions } from "./OrderKpoCardActions";
import { KpoBdoStatusBadge } from "../../Bdo/Kpo/KpoBdoStatusBadge";
import { stringToDate } from "../../../domain/Configuration";
import { useState } from "react";

export function OrderBdoCardDetailsView ({ kpoItem, orderItem, orderBdoInfo, orderDataBdo }) {
  const [isLoading, setIsLoading] = useState();

  return <Card key={kpoItem.kpoId}>
    <Card.Header>
      <b>{kpoItem.cardNumber ?? "00000/0000/KPO/0000/000000000"}</b>
    </Card.Header>
    {isLoading && <Card.Footer>
      <LoadingSpinner isLoading={isLoading} as="div" center/>
    </Card.Footer>}
    <Card.Body>
      <div className="d-flex justify-content-between align-items-start">
        <Card.Text><BadgeDomain>{kpoItem.wasteCode}</BadgeDomain></Card.Text>
        <div className="d-flex">
          <RefreshKpoCard orderId={orderItem.id} kpoId={kpoItem.kpoId} transactionType={orderItem.transactionType} cardNumber={kpoItem.cardNumber}/>
          <KpoBdoCardDetailsOffcanvas item={kpoItem}/>
          <KpoLinkFromOrder orderId={orderItem.id} kpoItem={kpoItem} orderNumber={orderItem.orderNumber}/>
          <KpoUnlinkFromOrder orderId={orderItem.id} kpoItem={kpoItem} orderNumber={orderItem.orderNumber}/>
          <KpoDriverInclude orderId={orderItem.id} kpoItem={kpoItem} kpoItems={orderBdoInfo.kpoCards}/>
          <KpoDriverExclude orderId={orderItem.id} kpoItem={kpoItem} kpoItems={orderBdoInfo.kpoCards}/>
          <OrderKpoCardActions orderData={orderDataBdo} kpoItem={kpoItem} performAll={false} kpoCards={[kpoItem]} setFileLoading={setIsLoading}/>
        </div>
      </div>
      <Card.Text>Masa: {kpoItem.wasteMass.toFixed(4)} [Mg]</Card.Text>
      <Card.Text>
        {<KpoBdoStatusBadge status={kpoItem.status}/>}
        {kpoItem.isRevised && <BadgeDomain bg="orange">Korekta {kpoItem.revisionNumber}</BadgeDomain>}
        {!!kpoItem.keoEntryId && <BadgeDomain bg="info">Wpis KEO</BadgeDomain>}
      </Card.Text>
      <Card.Text>Nr rejestracyjny: <BadgeDomain bg="success">{kpoItem.vehicleRegNumber}</BadgeDomain></Card.Text>
      {/*<Card.Text><b>Planowan</b> / <b>rzeczywista</b> data transportu</Card.Text>*/}
      <Card.Text>Planowana data transportu: <b className={kpoItem.isPlannedTransportTimeEligible ? "" : "error"}>{stringToDate(kpoItem.plannedTransportTime)}</b></Card.Text>
      <Card.Text>Rzeczywista data transportu: <b className={kpoItem.isPlannedTransportTimeEligible ? "" : "error"}>{stringToDate(kpoItem.realTransportTime)}</b></Card.Text>
      {kpoItem.collectionTime && <Card.Text>Data przyjęcia: <b>{stringToDate(kpoItem.collectionTime)}</b></Card.Text>}
      {kpoItem.additionalInfo && <Card.Text>Dodatkowe informacje: <i><b>{kpoItem.additionalInfo}</b></i></Card.Text>}
      <Card.Text>Uwagi: <i>{kpoItem.remarks ?? "-"}</i></Card.Text>
    </Card.Body>
  </Card>;
}